import axios from 'axios'
import { Message } from '@arco-design/web-react';
import { isNotEmpty } from "../util/Strings";
import { getToken, logout } from "./Manager";
import { LOGIN } from '../route';

const request = axios.create({
    timeout: 5000,
    responseType: "json",
    headers: {
        "Content-Type": "application/json;charset=utf-8",
        "Access-Control-Allow-Origin": "*"
    },
    baseURL: process.env.REACT_APP_API_ADDRESS
})


request.interceptors.request.use(
    config => {
        // 在发送请求之前做什么
        config.headers['token'] = getToken() //设置header
        return config;
    },
    error => {
        // 对请求错误处理
        Message.error(error);
        return Promise.reject(error);
    })

// response interceptor
request.interceptors.response.use(
    response => {
        // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
        // 否则的话抛出错误

        if (response.status === 200) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    // 服务器状态码不是2开头的的情况
    error => {
        if (error.response && error.response.status) {
            switch (error.response.status) {
                // 401: 未登录
                case 401:
                    logout()
                    //重定向到登录页
                    if (window.location.pathname !== LOGIN) {
                        window.location.href = LOGIN + "?redirectUri=" + encodeURIComponent(window.location.pathname + window.location.search)
                    }
                    break;
                // 403 token过期
                case 403:
                    Message.error('没有权限');
                    break;
                // 404请求不存在
                case 404:
                    Message.error('接口地址不存在');
                    break;
                case 500:
                    const data = error.response.data
                    if (data && isNotEmpty(data.message)) {
                        Message.error(data.message);
                    } else {
                        Message.error('系统错误');
                    }
                    break;
                // 其他错误，直接抛出错误提示
                default:
                    return Promise.reject(error.response);
            }
        } else {
            Message.error('请求失败');
            return Promise.reject(error.response);
        }
    }
);

export const post = async ({ url, data, errMsg, headers }) => {
    const res = await request.post(url, data, {
        headers: headers
    });
    if (!res) {
        return;
    }
    if (res.data.code === 200) {
        return res.data.data;
    } else {
        if (isNotEmpty(res.data.message)) {
            Message.error(res.data.message);
        } else if (isNotEmpty(errMsg)) {
            Message.error(errMsg);
        } else {
            Message.error('请求失败');
        }
    }
}

export const newWebSocket = (url) => {
    return new WebSocket(process.env.REACT_APP_WS_ADDRESS + url);
}